//スクロールによってclassを付ける(IntersectionObserver)
export function moveClass() {
	const target = document.querySelectorAll('.js-anime')
	const targetArray = Array.prototype.slice.call(target);

	//オプション設定
	const options = {
		root: null,
		rootMargin: '0px 0px',
		threshold: 0
	};

	const observer = new IntersectionObserver(callback, options)
	targetArray.forEach((tgt) => {
		observer.observe(tgt)
	});


	function callback(entries) {
		entries.forEach(function (entry, i) {
			const target = entry.target;
			if (entry.isIntersecting) {
				target.classList.add('is-move');
			}
		});
	};
}